import { Component, AfterViewChecked, OnInit, AfterViewInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import {UserService} from './services/user.service';
import { AppMenuItem } from './models/app-menu-item';
import { MenuItem } from './models/menu-item';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { Language } from './models/language';
import {Title} from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EnviromentService } from './services/enviroment.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { DateAdapter } from '@angular/material/core';
import { MenuService } from './services/menu.service';
import { EnviromentSettings } from './modules/enviroment/settings.model';

//screen.orientation.lock('landscape');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked, OnInit, AfterViewInit {
  activeApp: AppMenuItem;
  isExpanded = false;
  title = null;
  screenWidth: number;
  isFullScreen = false;
  public showExpanded: Subject<boolean> = new BehaviorSubject(false);
  private ExpandedKey = 'ISSIDENAVEXPANDED';
  public envSettings:EnviromentSettings;
  public autoLogin = 'yes';
  public fbAddId = null;
  activeparams: Params;
  menuItems = {
    dws: [
      {
        id: 'documents',
        label: 'dws.documents',
        icon: 'fa fa-file',
        route: '/documents'
      },
      {
        id: 'types',
        label: 'dws.types',
        icon: 'list',
        route: '/documentType'
      }
    ],
    administration: [
      {
        id: 'accounts',
        label: 'administration.accountInfos',
        icon: 'list',
        route: '/administration/accounts'
      },
      {
        id: 'roles',
        label: 'administration.roles',
        icon: 'list',
        route: '/administration/roles'
      },
      {
        id: 'users',
        label: 'administration.users',
        icon: 'list',
        route: '/administration/users'
      }
    ],
    timeTracking: [
      {
        id: 'dashboard',
        label: 'timeTracking.dasboard',
        icon: 'home',
        route: '/timeTracking'
      },
      {
        id: 'status',
        label: 'timeTracking.status',
        icon: 'group',
        route: '/timeTracking/status'
      },
      {
        id: 'types',
        label: 'timeTracking.types',
        icon: 'list',
        route: '/timeTracking/types'
      },
      {
        id: 'schedules',
        label: 'timeTracking.schedules',
        icon: 'list',
        route: '/timeTracking/schedules'
      },
      {
        id: 'entrys',
        label: 'timeTracking.list',
        icon: 'list',
        route: '/timeTracking/items'
      }
    ],
    plasardMeasurement: [
      {
        id: 'item',
        label: 'plasardMeasurement.items',
        icon: 'list',
        route: '/plasard-measurement/item'
      },            
      {
        id: 'doorType',
        label: 'plasardMeasurement.doorType',
        icon: 'list',
        route: '/plasard-measurement/door-type'
      },
      {
        id: 'insideType',
        label: 'plasardMeasurement.insideType',
        icon: 'list',
        route: '/plasard-measurement/inside-type'
      },
      {
        id: 'inside',
        label: 'plasardMeasurement.inside',
        icon: 'list',
        route: '/plasard-measurement/inside'
      },      
      {
        id: 'layoutType',
        label: 'plasardMeasurement.layoutType',
        icon: 'list',
        route: '/plasard-measurement/layout-type'
      },      
      {
        id: 'layout',
        label: 'plasardMeasurement.layout',
        icon: 'list',
        route: '/plasard-measurement/layout'
      },
      {
        id: 'decorType',
        label: 'plasardMeasurement.decorType',
        icon: 'list',
        route: '/plasard-measurement/decor-type'
      },
      {
        id: 'decor',
        label: 'plasardMeasurement.decor',
        icon: 'list',
        route: '/plasard-measurement/decor'
      },
      {
        id: 'standard',
        label: 'plasardMeasurement.standard',
        icon: 'list',
        route: '/plasard-measurement/standard'
      },
      {
        id: 'customerList',
        label: 'plasardMeasurement.customerPortalList',
        icon: 'list',
        route: '/plasard-measurement/customer'
      },
      {
        id: 'customer',
        label: 'plasardMeasurement.customerPortal',
        icon: 'list',
        route: '/plasard-measurement/customer/add'
      }
    ],
    analytics:[
      // {
      //   id: 'dashboard',
      //   label: 'timeTracking.dasboard',
      //   icon: 'home',
      //   route: '/analytics'
      // }      
    ]
  };
  sideNav: MenuItem[] = [];
  isSidenavOpen = false;
  onToggleSideNav(value: boolean) {
    this.isSidenavOpen = value;
    this.showExpanded.next(this.isSidenavOpen);
  }

  ngAfterViewChecked(): void {

  }
  private initEvnviroment(){
    if(this.envSettings){
      this.translateService.setDefaultLang(this.envSettings.defaultLanguage);
      if(this.envSettings.autoLogin && this.envSettings.basicAuth){
        const credentials:string = atob(this.envSettings.basicAuth);
        if(credentials && this.autoLogin === 'yes'){
          const credData:string[] = credentials.split(':');
          if(credData.length>0){
            this.userService.login(credData[0],credData[1]).subscribe(_ => {
              if(this.envSettings.defaultRoute){
                var params = {};
                const qparamKeys = Object.keys(this.activeparams);
                for (let p = 0; p < qparamKeys.length; p++) {
                  const key = qparamKeys[0];
                  if(key.startsWith('feature')){
                    params[key] = this.activeparams[key];
                  }
                }
                if(this.fbAddId){
                  params['fbAddId'] = this.fbAddId;
                }
                this.router.navigate([this.envSettings.defaultRoute], { queryParams: params }); // this.envSettings.defaultRoute
              }
            });
          }
        }
        else if(this.autoLogin === 'no') {
            this.envSettings.fullScreen = false;
            this.envSettings.autoLogin = false;
            this.router.navigateByUrl('/login');
        }
      }      
    }
  }
  ngOnInit(): void {        
    this.route.queryParams.subscribe(params => {
        this.activeparams = params;
        if(params.autoLogin !== undefined){
          this.autoLogin = params.autoLogin;
        }
        if(params.fbAddId !== undefined){
          this.fbAddId = params.fbAddId;
        }
        this.enviromentService.getSettings(this.autoLogin).subscribe(res => {      
          if(res){
            this.enviromentService.storeLocal('env',JSON.stringify(res));
            this.envSettings = res;
            this.initEvnviroment();                            
          }
        });
        setTimeout(() => {
          const title = this.translateService.instant('app.title');
          if(title !== 'app.title'){
            this.title = title;
            this.titleService.setTitle(this.title);
          }
        },700);                
      }
    );
  }

  constructor(
    private translateService: TranslateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private enviromentService: EnviromentService,
    private dateAdapter: DateAdapter<any>,
    private menuService: MenuService,
    private userService: UserService,
    ) {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };    
    this.matIconRegistry.addSvgIcon(
      'language-si',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/language-si.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'language-hr',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/language-hr.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'language-en',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/language-en.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'language-de',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/language-de.svg')
    );
  }
  ngAfterViewInit(): void {
    this.screenWidth = window.innerWidth;
    const expanded = this.enviromentService.getLocal(this.ExpandedKey);
    if (expanded) {
      this.isExpanded = expanded === 'true';
    }
    setTimeout(() => {
      this.showExpanded.next(this.isExpanded);                  
    }, 5);            
  }

  askForCookieConsent(){   
    let cc = window as any;
           cc.cookieconsent.initialise({
             palette: {
               popup: {
                 background: "#164969"
               },
               button: {
                 background: "#ffe000",
                 text: "#164969"
               }
             },
             theme: "classic",
             content: {
               message: "Z brskanjem po naši spletni strani se strinjate, da lahko uporabljamo piškotke, ki so namenjeni vaši boljši uporabniški izkušnji na naši spletni strani. Za lastne potrebe analitike uporabljamo Google Analytics, ki v ta namen namesti piškotke",
               dismiss: "izbriši GA piškotke",
               link: "Več o piškotkih",
               href: "https://plasard.si/piskotki/" 
             }
           });
  }

  onAppChange(app: AppMenuItem) {  
    if (app) {      
      //aaa
      this.menuService.GetDynamicItems(app.code).subscribe((result)=>{
        let sideNavMenu:MenuItem[] = this.menuItems[app.code];
        if(result && result.payload){
          // aaa
          sideNavMenu = [...sideNavMenu, ...(result.payload.map(item => {
            return <MenuItem>{
              id: item.id,
              code: item.code,
              label: item.name,
              route: `/analytics/${item.code}`
            }
          }))]
        }
        this.sideNav = sideNavMenu;

        this.activeApp = app;
        if (this.activeApp) {
          this.title = this.translateService.instant(this.activeApp.name);
          this.titleService.setTitle(this.title);
        }
        if (this.sideNav && this.sideNav.length > 0) {
          this.router.navigate([this.sideNav[0].route]);
        }
      });      
    } else {
      this.sideNav = null;
    }
  }

  onExpandChange(expanded: boolean) {
    this.isExpanded = expanded;
    this.enviromentService.storeLocal(this.ExpandedKey, expanded ? 'true' : 'false');
    this.showExpanded.next(this.isExpanded);
  }
  onLanguageSelected(language: Language) {
    if (language && language.code) {
      this.translateService.use(language.code);
      this.dateAdapter.setLocale(language.code);
      this.onAppChange(this.activeApp);
    }
  }
}
